import service from '@/services/service'

const resource = {
    main: 'services',
    module: 'statement-notifications'
}

const templateResource = {
    main: 'services',
    module: 'statement-notification-template'
}

const filtersResource = {
    main: 'services',
    module: 'filters'
}

export class StatementNotificationService {
    public static getAll () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getByProvider (providerId: number) {
        return service.get(`${resource.main}/${resource.module}/provider/${providerId}`)
    }

    public static getById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static create (params: { providerId: number; emails: string; subject: string; body: string }) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static update (id: number, params: { emails: string; subject: string; body: string }) {
        return service.put(`${resource.main}/${resource.module}/${id}`, params)
    }

    public static delete (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static send (statementId: number) {
        return service.post(`${resource.main}/${resource.module}/send/${statementId}`)
    }

    public static getTemplate () {
        return service.get(`${templateResource.main}/${templateResource.module}`)
    }

    public static saveTemplate (params: { subject: string; body: string }) {
        return service.post(`${templateResource.main}/${templateResource.module}`, params)
    }

    public static getUsersByProvider (providerId: number) {
        return service.get(`${filtersResource.main}/${filtersResource.module}/users`, {
            params: { providerId }
        })
    }
}
